import React, { useState, useEffect, useRef } from "react";
import { Button } from "../Button";
import { ConfirmatioPopupWrapper } from "./styles";
import { InfoCircleFilled } from "@ant-design/icons";

const ConfirmationPopup = ({ children, message, onConfirm, onCancel, position = "top", confirmText = "Ok", cancelText = "Cancel", disabled = false, icon = false }) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleOutside(e) {
      if (!wrapperRef.current) return;
      if (!wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    }

    function handleKey(e) {
      if (e.key === "Escape") setOpen(false);
      if (e.key === "Enter" && open) {
        e.preventDefault();
        handleConfirm();
      }
    }

    document.addEventListener("mousedown", handleOutside);
    document.addEventListener("keydown", handleKey);

    return () => {
      document.removeEventListener("mousedown", handleOutside);
      document.removeEventListener("keydown", handleKey);
    };
  }, [open]);

  const toggleOpen = (e) => {
    if (disabled) return;
    e && e.stopPropagation();
    setOpen((s) => !s);
  };

  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    setOpen(false);
  };

  const handleCancel = () => {
    if (onCancel) onCancel();
    setOpen(false);
  };

  return (
    <ConfirmatioPopupWrapper ref={wrapperRef} className={`confirmation-wrapper position-${position}`}>
      <span className={`confirmation-trigger ${disabled ? "disabled" : ""}`} tabIndex={0} onClick={toggleOpen} onKeyDown={(e) => e.key === "Enter" && toggleOpen(e)}>
        {children}
      </span>

      {open && (
        <div className={`confirmation-popup ${position}`} role="dialog" aria-modal="true">
          <div className="confirmation-content">
            {icon === "info" && (
              <InfoCircleFilled
                style={{
                  // color: "#1890ff",
                  color: "#faad14",
                  marginRight: 8,
                  marginTop: 2,
                }}
              />
            )}
            {message}
          </div>
          <div className="confirmation-actions">
            <Button size={"small"} ghost type="secondary" className="btn btn-cancel" onClick={handleCancel}>
              {cancelText}
            </Button>
            <Button size={"small"} type="primary" className="btn btn-confirm" onClick={handleConfirm}>
              {confirmText}
            </Button>
          </div>
        </div>
      )}
    </ConfirmatioPopupWrapper>
  );
};

export { ConfirmationPopup };
